export default __webpack_public_path__ + "static/media/drone-industry-insights.0236aa24.png";